import { Routes, Route } from 'react-router-dom';

import Header from './routes/header/header.component';
import Home from './routes/home/home.component';
import Footer from './routes/footer/footer.component';
// import Estate from './routes/estate/estate.component';
import UnderConstruction from './routes/underConstruction/underConstruction.component';

import './App.css';


const App = () => {
  return (
    <Routes>
      <Route path='/' element={<UnderConstruction />}>
        <Route path='/' element={<Header />}>
          <Route path='/' element={<Footer />}>
            <Route index element={<Home />} />
            {/* <Route path='estate/*' element={<Estate />} /> */}
          {/* <Route path='about-us' element={<AboutUs />} />
            <Route path='products' element={<Products />} /> */}
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;